import { BLOG_CATEGORY, buildBlogFilePath, type BlogMetaData } from '../types';

export const parentingConsultation: BlogMetaData = {
  title: '子育て相談はどこにすべき？無料窓口・育児相談オンラインまで悩み別ガイド',
  description:
    '子育て相談・育児相談の窓口を悩み別に整理。無料の公的窓口からオンライン相談まで、子育て悩み相談先の選び方をモンテッソーリ歴20年以上のプロが解説します。',
  thumbnailUrl: '/img/blog-parenting-consultation.png',
  filePath: buildBlogFilePath('parenting-consultation'),
  category: BLOG_CATEGORY.PARENTING,
};
